import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Pago from '../components/Pago';

const CarritoPage: React.FC = () => {
  return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Banner />
        <div style={{ flex: 1 }}>
        <Pago />
        </div>
      <Footer />
    </div>
  );
};

export default CarritoPage;
